import { CONFIGURABLE_MESSAGE_AND_ICON_MAP } from '../../common/constants/index.tsx';
import type { ConfigurableMenuId } from '../../common/types.tsx';
import { useFormattedMessageAndIcon } from '../../common/utils/use-formatted-message-and-icon/index.tsx';

export const useConfigurableMessageAndIconMap = (menuId: ConfigurableMenuId) => {
	const { message, Icon } = CONFIGURABLE_MESSAGE_AND_ICON_MAP[menuId];

	return useFormattedMessageAndIcon(message, Icon);
};
